import styled from "styled-components";
import Skeleton from "../../../../../../../structures/others/skeleton/index.js";
import { FlexMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { Margin } from "../../../../../../../../styles/common/mixins/logical.styled.js";
import { SearcherItem } from "../../../../styled.js";
export const SearcherSkeletonContent = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherSkeletonContent",
    componentId: "sc-dbe914d0-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'flex-end'
})}
	column-gap: 16px;
	${Margin({
    left: 'auto'
})}
	${({ $grow =false  })=>`flex-grow: ${$grow ? 1 : 0};`}
`;
export const SearcherSkeletonButton = styled(Skeleton).withConfig({
    displayName: "styled__SearcherSkeletonButton",
    componentId: "sc-dbe914d0-1"
})`
	min-width: 150px;
	max-width: 160px;
`;
export const SkeletonWrapper = styled.div.withConfig({
    displayName: "styled__SkeletonWrapper",
    componentId: "sc-dbe914d0-2"
})`
	${FlexMixin({
    align: 'center',
    direction: 'column'
})}
	flex-grow: ${({ $grow  })=>$grow ? 1 : 0};
	row-gap: 4px;
`;
export const SkeletonText = styled(Skeleton).withConfig({
    displayName: "styled__SkeletonText",
    componentId: "sc-dbe914d0-3"
})``;

//# sourceMappingURL=styled.js.map